export const FEATURE_NAME = '@zerops/zerops/feature/project-envs-edit-dialog';
